import { jsx as _jsx } from "react/jsx-runtime";
import { useWidth } from "common-frontend-components";
export const ImageFullViewStyle = () => {
    const width = useWidth();
    return (_jsx("style", { children: `
/* https://www.w3schools.com/howto/howto_js_slideshow.asp */

/* Slideshow container */
.slideshow-container-ImageFullView {
    max-width: 1000px;
    position: relative;
    margin: auto;
}

/* Hide the images by default */
.mySlides-ImageFullView {
    display: none;
}

/* Next & previous buttons */
.prev-ImageFullView, .next-ImageFullView {
    cursor: pointer;
    position: absolute;
    top: 50%;
    width: auto;
    margin-top: -22px;
    padding: 16px;
    color: white;
    font-weight: bold;
    font-size: 18px;
    transition: 0.6s ease;
    border-radius: 0 3px 3px 0;
    user-select: none;
}

/* Position the "next button" to the right */
.next-ImageFullView {
    right: 0;
    border-radius: 3px 0 0 3px;
}

/* On hover, add a black background color with a little bit see-through */
.prev-ImageFullView:hover, .next-ImageFullView:hover {
/*.prev-ImageFullView, .next-ImageFullView {*/
    background-color: rgba(0,0,0,0.8);
}

/* Caption text */
.text-ImageFullView {
    color: #f2f2f2;
    font-size: 15px;
    padding: 8px 12px;
    position: absolute;
    bottom: 8px;
    width: 100%;
    text-align: center;
}

/* Number text (1/3 etc) */
.numbertext-ImageFullView {
    color: #f2f2f2;
    font-size: 12px;
    padding: 8px 12px;
    position: absolute;
    top: 0;
}

/* The dots/bullets/indicators */
.dot-ImageFullView {
    cursor: pointer;
    height: 15px;
    width: 15px;
    margin: 0 2px;
    background-color: #bbb;
    border-radius: 50%;
    display: inline-block;
    transition: background-color 0.6s ease;
}

.active-ImageFullView, .dot-ImageFullView:hover {
    background-color: #717171;
}

/* Fading animation */
.fade-ImageFullView {
    /*-webkit-animation-name: fade-ImageFullView;*/
    /*-webkit-animation-duration: 1.5s;*/
    /*animation-name: fade-ImageFullView;*/
    /*animation-duration: 1.5s;*/
}

@-webkit-keyframes fade-ImageFullView {
    from {opacity: .4}
    to {opacity: 1}
}

@keyframes fade-ImageFullView {
    from {opacity: .4}
    to {opacity: 1}
}

@keyframes ImageFullView-backgroundloop {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position:-${width}px 0;
  }
}
` }, void 0));
};
//# sourceMappingURL=ImageFullViewStyle.js.map